<template>
    <b-container fluid class='home-container p-0'>
        <section-inicio :content="section_inicio"/>
        <router-view></router-view>
    </b-container>
</template>

<script>
    import SectionInicio from '@/components/section-inicio'

    export default {
        name: 'Inicio',
        components: {
            SectionInicio
        },
        data: () => ({
            section_inicio: {
                titulo: 'Puntos que <span>sí</span> suman',
                subtitulo: 'Recupera tu contraseña:',
                content: 'Ingresa tu correo electrónico para enviarte un código para restablecer tu contraseña.'
            }
        }),
        methods: {}
    }
</script>
<style scoped>
</style>
